export enum BrandKitSwatchClusterVariant {
  DEFAULT = 'default',
  COMPACT = 'compact',
  /** Compact-sized swatches side by side with a gap, so every colour shows in full. */
  SPACED = 'spaced',
}

export interface BrandKitSwatchClusterProps {
  logoURL?: string;
  colorHexes: string[];
  variant?: BrandKitSwatchClusterVariant;
  /** Shows at most this many colours, then a "+N" count of the rest. Unset shows every colour passed. */
  colorLimit?: number;
}

export const BRAND_KIT_SWATCH_COLORS_LIMIT = 2;
